const menuInfo = {
  namespaced: true,
  state: {
    menuInfo: {
      userEntries: [],
      allMenus: {},
      // 入口菜單 根據編碼匹配
      entryMenus: {},
      structure: '',
      //当前访问子系统编码
      entryCode: '',
      entryName: '',
      viewType: '',
      menuLayoutType: 'LEFT',
      //当前选中入口的菜单
      mainMenus: {},
      activeName: '',
      openNames: [],
      isCollapsed: false,
      isBack: false,
      cockpitCode: 'default'
    }
  },
  getters: {
    menuInfo: state => state.menuInfo,
    allMenus: state => state.menuInfo?.allMenus,
    userEntries: state => state.menuInfo?.userEntries || [],
    structure: state => state.menuInfo?.structure,
    entryMenus: state => state.menuInfo?.entryMenus || {},
    entryCode: state => state.menuInfo?.entryCode,
    mainMenus: state => state.menuInfo?.mainMenus,
    activeName: state => state.menuInfo?.activeName,
    isCollapsed: state => state.menuInfo?.isCollapsed,
    isBack: state => state.menuInfo?.isBack,
    openNames: state => state.menuInfo?.openNames || [],
    cockpitCode: state => state.menuInfo?.cockpitCode || 'default',
  },
  mutations: {
    SET_MENUINFO (state, payload) {
      state.menuInfo = payload
    },
    SET_MENUINFO_PARAMTER (state, payload) {
      // 直接异常抛掉
      if (payload.key == undefined || payload.key == null) throw Error("please check data key!")
      state.menuInfo[payload.key] = payload.value
    },
  },
  actions: {
    // 登录操作
    async updateMenuInfo (context, data) {
      // 触发mutation，存储data
      context.commit("SET_MENUINFO", data)
    },
    async updateMenuInfoParams (context, data) {
      // 触发mutation，存储data
      if (data instanceof Array) {
        data.forEach(item => {
          context.commit("SET_MENUINFO_PARAMTER", item)
        })
      } else {
        context.commit("SET_MENUINFO_PARAMTER", data)
      }
    },
  }
}

export default menuInfo